// extracted by mini-css-extract-plugin
export var container = "blog-module--container--3CY3b";
export var imageContainer = "blog-module--imageContainer--IqGwq";
export var image = "blog-module--image--12J6s";
export var description = "blog-module--description--kNrBe";